.firm-sub-account-users-grid-host{min-height:200px}
/*# sourceMappingURL=sub-account-users-grid-host.component-X6NSVIWO.css.map */
